import * as React from 'react';
import styles from './index.less';
import LuckyBox from './LuckyBox';
import WinnerAnnouncementModal, {
  type WinnerAnnouncementResourceItem,
} from './WinnerAnnouncementModal';
// import imgFuPattern from './img/fu_pattern.svg';
import imgBanner from './img/banner.svg';
import imgSubmitIcon from './img/submit_icon.svg';
import imgShareIcon from './img/share_icon.svg';
import imgRedPacket from './img/red_packet.svg';
import img_title_activity_about from './img/title_activity_about.png';
import img_activity_time from './img/activity_time.png';
import img_get_alpha_test from './img/get_alpha_test.png';
import img_activity_mechanism from './img/activity_mechanism.png';
import img_title_new_year_authenticate from './img/title_new_year_authenticate.png';
import img_stage_1 from './img/stage_1.png';
import img_stage_2 from './img/stage_2.png';
import img_stage_3 from './img/stage_3.png';
import img_not_start from './img/not_start.png';
import img_in_progress from './img/in_progress.png';
import img_have_finished from './img/have_finished.png';
import img_extract_material from './img/extract_material.png';
// import img_content_bg from './img/content_bg-71a289.png';
// import img_author_avatar from './img/author_avatar.png';
// import img_resource_cover from './img/resource_cover.png';
// import img_artifact_cover from './img/artifact_cover.png';
// import img_content_bg from './img/content_bg-71a289.png';
// import img_author_avatar from './img/author_avatar.png';
// import img_resource_cover from './img/resource_cover.png';
// import img_artifact_cover from './img/artifact_cover.png';
// import img_excellent_works_bg from './img/excellent_works_bg-71a289.png';
// import img_resource_cover_1 from './img/resource_cover_1.png';
// import img_resource_cover_2 from './img/resource_cover_2.png';
// import img_resource_cover_3 from './img/resource_cover_3.png';
// import img_author_avatar_1 from './img/author_avatar_1.png';
// import img_author_avatar_2 from './img/author_avatar_2.png';
// import img_author_avatar_3 from './img/author_avatar_3.png';
import img_award_setting from './img/award_setting.png';
import img_painted_eggshell from './img/painted_eggshell.png';
import img_red_packet_cover from './img/red_packet_cover.png';
import img_newbie_guide from './img/newbie_guide.png';
import img_submission_of_works from './img/submission_of_works.png';
import img_guide_step_1_bg from './img/guide_step_1_bg.png';
import img_guide_step_2_bg from './img/guide_step_2_bg.png';
import img_guide_step_3_bg from './img/guide_step_3_bg.png';
import img_guide_step_4_bg from './img/guide_step_4_bg.png';
import img_official_channels from './img/official_channels.png';
// import img_reward_bg from './img/reward_bg.png';
// import img_xiaohongshu_qr from './img/xiaohongshu_qr.png';
// import img_weibo_qr from './img/weibo_qr.png';
// import img_qq_qr from './img/qq_qr.png';
// import img_weixin_qr from './img/weixin_qr.png';
import img_xiaohongshu_qr from '@/assets/activity/SpringFestival/xiaohongshuAvatar.png';
import img_weibo_qr from '@/assets/activity/SpringFestival/weibaoAvatar.png';
import img_qq_qr from '@/assets/activity/SpringFestival/QQChatQR.jpg';
import img_weixin_qr from '@/assets/activity/SpringFestival/weixinQR.jpg';
import img_activity_rules from './img/activity_rules.png';
import img_sider_bg from './img/sider_bg.png';
// import img_content_bg from './img/content_bg.png';
import { connect, Dispatch } from 'umi';
import { ActivityDetailsPageModelState } from '@/models/activityDetailsPage';
import { ConnectState } from '@/models/connect';
import { FUtil, FServiceAPI, FI18n } from '@freelog/tools-lib';
import dayjs from 'dayjs';
import * as AHooks from 'ahooks';
import fWeiXinShare from '@/components/fWeiXinShare';
import fCenterMessage from '@/components/fCenterMessage';
import copy from 'copy-to-clipboard';
import FComponentsLib from '@freelog/components-lib';
import FFooter from '@/components/Footer';
import { i18nUrl } from '@/utils/i18nUrl';

/** 阶段时间为纯文本 i18n，只给 dayjs 用；用 .t 取 string（tAuto 可能返回 React 节点）。 */
function springFestival2026StageDateText(key: string): string {
  return FI18n.i18nNext.t(key) as string;
}

function dayjsFromI18nZh(raw: unknown): dayjs.Dayjs {
  const s = typeof raw === 'string' ? raw : '';
  return dayjs(s);
}

interface SpringFestival2026Props {
  dispatch: Dispatch;
  activityDetailsPage: ActivityDetailsPageModelState;
}

function SpringFestival2026({ dispatch, activityDetailsPage }: SpringFestival2026Props) {
  const ref_content1 = React.useRef<HTMLImageElement>(null);
  const ref_content2 = React.useRef<HTMLImageElement>(null);
  const ref_content3 = React.useRef<HTMLDivElement>(null);
  const ref_content4 = React.useRef<HTMLDivElement>(null);
  const ref_content5 = React.useRef<HTMLDivElement>(null);
  const ref_content6 = React.useRef<HTMLDivElement>(null);

  const [$activated, set$activated, get$activated] = FUtil.Hook.useGetState<number>(1);

  const [$isLogined, set$isLogined, get$isLogined] = FUtil.Hook.useGetState<boolean>(false);
  const [$isRegister, set$isRegister, get$isRegister] = FUtil.Hook.useGetState<boolean>(false);

  const [$announceShow, set$announceShow, get$announceShow] =
    FUtil.Hook.useGetState<boolean>(false);
  const [$momentTime, set$momentTime, get$momentTime] =
    FUtil.Hook.useGetState<dayjs.Dayjs>(dayjs());

  const [$collectTime, set$collectTime, get$collectTime] = FUtil.Hook.useGetState<
    Record<
      | 'stage1Start'
      | 'stage1End'
      | 'stage1Announce'
      | 'stage2Start'
      | 'stage2End'
      | 'stage2Announce'
      | 'stage3Start'
      | 'stage3End'
      | 'stage3Announce',
      dayjs.Dayjs
    >
  >({
    stage1Start: dayjs(springFestival2026StageDateText('event_2026SpringFestivalRound1_startdate')),
    stage1End: dayjs(springFestival2026StageDateText('event_2026SpringFestivalRound1_enddate')),
    stage1Announce: dayjs(springFestival2026StageDateText('event_2026SpringFestivalRound1_result')),
    stage2Start: dayjs(springFestival2026StageDateText('event_2026SpringFestivalRound2_startdate')),
    stage2End: dayjs(springFestival2026StageDateText('event_2026SpringFestivalRound2_enddate')),
    stage2Announce: dayjs(springFestival2026StageDateText('event_2026SpringFestivalRound2_result')),
    stage3Start: dayjs(springFestival2026StageDateText('event_2026SpringFestivalRound3_startdate')),
    stage3End: dayjs(springFestival2026StageDateText('event_2026SpringFestivalRound3_enddate')),
    stage3Announce: dayjs(springFestival2026StageDateText('event_2026SpringFestivalRound3_result')),
  });

  const [$collectTimeStatus, set$collectTimeStatus, get$collectTimeStatus] = FUtil.Hook.useGetState<
    Record<'stage1' | 'stage2' | 'stage3', 'notStart' | 'inProgress' | 'finished'>
  >({
    stage1: 'notStart',
    stage2: 'notStart',
    stage3: 'notStart',
  });

  const [$luckyBox1Results, set$luckyBox1Results, get$luckyBox1Results] = FUtil.Hook.useGetState<
    {
      imgUrl: string;
      name: string;
    }[]
  >([]);
  const [$luckyBox2Results, set$luckyBox2Results, get$luckyBox2Results] = FUtil.Hook.useGetState<
    {
      imgUrl: string;
      name: string;
    }[]
  >([]);
  const [$luckyBox3Results, set$luckyBox3Results, get$luckyBox3Results] = FUtil.Hook.useGetState<
    {
      imgUrl: string;
      name: string;
    }[]
  >([]);

  const [$isAllParticipate, set$isAllParticipate, get$isAllParticipate] =
    FUtil.Hook.useGetState<boolean>(false);

  const [$hasSpringFestivalJoyPrize, set$hasSpringFestivalJoyPrize, get$hasSpringFestivalJoyPrize] =
    FUtil.Hook.useGetState<boolean>(false);

  const [$topicResults, set$topicResults, get$topicResults] = FUtil.Hook.useGetState<{
    topic1: {
      avatar: string;
      username: string;
      work: {
        resourceID: string;
        resourceCover: string;
        resourceTitle: string;
        materials: string[];
      };
      keepsake: {
        resourceID: string;
        resourceCover: string;
        resourceTitle: string;
        downloadURL: string;
      };
    };
    topic2: {
      resourceID: string;
      resourceCover: string;
      resourceTitle: string;
      materials: string[];
      username: string;
      avatar: string;
    }[];
    topic3: {
      avatar: string;
      username: string;
      work: {
        resourceID: string;
        resourceCover: string;
        resourceTitle: string;
        materials: string[];
      };
      keepsake: {
        resourceID: string;
        resourceCover: string;
        resourceTitle: string;
        downloadURL: string;
      };
    };
    topic4: {
      resourceID: string;
      resourceCover: string;
      resourceTitle: string;
      materials: string[];
      username: string;
      avatar: string;
    }[];
    topic5: {
      avatar: string;
      username: string;
      work: {
        resourceID: string;
        resourceCover: string;
        resourceTitle: string;
        materials: string[];
      };
    };
    topic6: {
      resourceID: string;
      resourceCover: string;
      resourceTitle: string;
      materials: string[];
      username: string;
      avatar: string;
    }[];
  } | null>(null);

  const [$winnerAnnouncement, set$winnerAnnouncement] = FUtil.Hook.useGetState<{
    bestCreative: WinnerAnnouncementResourceItem[];
    excellent: WinnerAnnouncementResourceItem[];
    fullParticipationUsernames: string[];
    springExpertUsernames: string[];
  }>({
    bestCreative: [],
    excellent: [],
    fullParticipationUsernames: [],
    springExpertUsernames: [],
  });

  const position = AHooks.useScroll(
    self.document.querySelector('#layout-content .simplebar-content-wrapper'),
  );

  React.useEffect(() => {
    const info1 = ref_content1.current?.getBoundingClientRect();
    const info2 = ref_content2.current?.getBoundingClientRect();
    const info3 = ref_content3.current?.getBoundingClientRect();
    const info4 = ref_content4.current?.getBoundingClientRect();
    const info5 = ref_content5.current?.getBoundingClientRect();
    const info6 = ref_content6.current?.getBoundingClientRect();
    if (info6 && info6.top <= 72) {
      set$activated(6);
    } else if (info5 && info5.top <= 72) {
      set$activated(5);
    } else if (info4 && info4.top <= 72) {
      set$activated(4);
    } else if (info3 && info3.top <= 72) {
      set$activated(3);
    } else if (info2 && info2.top <= 72) {
      set$activated(2);
    } else {
      set$activated(1);
    }
  }, [position]);

  AHooks.useMount(async () => {
    if (FUtil.Tool.getUserIDByCookies() === -1) {
      return;
    }
    set$isLogined(true);
    const {
      data,
    }: {
      data: {
        userType: 0 | 1;
      };
    } = await FServiceAPI.User.currentUserInfo();
    set$isRegister(data.userType === 1);
  });

  AHooks.useMount(async () => {
    if (FUtil.Tool.getUserIDByCookies() === -1) {
      return;
    }
    const {
      data: data1,
    }: {
      data: {
        data: {
          capsuleType: 1 | 2 | 3;
          imgUrl: string;
          name: string;
        };
      }[];
    } = await FServiceAPI.Activity.lotteryDrawResult({
      capsuleType: 1,
    });
    // console.log(data, 'data890i/oewjfsdlkfjlsdkfjlkj');
    set$luckyBox1Results(data1.map((d) => ({ imgUrl: d.data.imgUrl, name: d.data.name })));

    const {
      data: data2,
    }: {
      data: {
        data: {
          capsuleType: 1 | 2 | 3;
          imgUrl: string;
          name: string;
        };
      }[];
    } = await FServiceAPI.Activity.lotteryDrawResult({
      capsuleType: 2,
    });
    set$luckyBox2Results(data2.map((d) => ({ imgUrl: d.data.imgUrl, name: d.data.name })));

    const {
      data: data3,
    }: {
      data: {
        data: {
          capsuleType: 1 | 2 | 3;
          imgUrl: string;
          name: string;
        };
      }[];
    } = await FServiceAPI.Activity.lotteryDrawResult({
      capsuleType: 3,
    });
    set$luckyBox3Results(data3.map((d) => ({ imgUrl: d.data.imgUrl, name: d.data.name })));
  });

  AHooks.useMount(async () => {
    const res = await fetch(`${i18nUrl()}?timestamp=${Date.now()}`);
    // console.log(await res.json(), 'res890i/oewjfsdlkfjlsdkfjlkj');

    const i18n_json: any = await res.json();

    const stage1Start_dayjs = dayjsFromI18nZh(
        i18n_json['event_2026SpringFestivalRound1_startdate']?.['zh_CN'],
      ),
      stage1End_dayjs = dayjsFromI18nZh(i18n_json['event_2026SpringFestivalRound1_enddate']?.['zh_CN']),
      stage1Announce_dayjs = dayjsFromI18nZh(
        i18n_json['event_2026SpringFestivalRound1_result']?.['zh_CN'],
      ),
      stage2Start_dayjs = dayjsFromI18nZh(
        i18n_json['event_2026SpringFestivalRound2_startdate']?.['zh_CN'],
      ),
      stage2End_dayjs = dayjsFromI18nZh(i18n_json['event_2026SpringFestivalRound2_enddate']?.['zh_CN']),
      stage2Announce_dayjs = dayjsFromI18nZh(
        i18n_json['event_2026SpringFestivalRound2_result']?.['zh_CN'],
      ),
      stage3Start_dayjs = dayjsFromI18nZh(
        i18n_json['event_2026SpringFestivalRound3_startdate']?.['zh_CN'],
      ),
      stage3End_dayjs = dayjsFromI18nZh(i18n_json['event_2026SpringFestivalRound3_enddate']?.['zh_CN']),
      stage3Announce_dayjs = dayjsFromI18nZh(
        i18n_json['event_2026SpringFestivalRound3_result']?.['zh_CN'],
      );

    set$collectTime({
      stage1Start: stage1Start_dayjs,
      stage1End: stage1End_dayjs,
      stage1Announce: stage1Announce_dayjs,
      stage2Start: stage2Start_dayjs,
      stage2End: stage2End_dayjs,
      stage2Announce: stage2Announce_dayjs,
      stage3Start: stage3Start_dayjs,
      stage3End: stage3End_dayjs,
      stage3Announce: stage3Announce_dayjs,
    });

    const momentTime = dayjs();

    set$collectTimeStatus({
      stage1: momentTime.isBefore(stage1Start_dayjs)
        ? 'notStart'
        : momentTime.isAfter(stage1End_dayjs)
          ? 'finished'
          : 'inProgress',
      stage2: momentTime.isBefore(stage2Start_dayjs)
        ? 'notStart'
        : momentTime.isAfter(stage2End_dayjs)
          ? 'finished'
          : 'inProgress',
      stage3: momentTime.isBefore(stage3Start_dayjs)
        ? 'notStart'
        : momentTime.isAfter(stage3End_dayjs)
          ? 'finished'
          : 'inProgress',
    });
  });

  AHooks.useMount(async () => {
    type TopicElemDetail = {
      resourceId: string;
      resourceName: string;
      resourceTitle: string;
      resourceType: string[];
      coverImages: string[];
      userId: number;
      username: string;
      latestVersion: string;
    };
    const [
      topic1_data,
      topic2_data,
      topic3_data,
      topic4_data,
      topic5_data,
      topic6_data,
      topicBestCreative_data,
      topicExcellent_data,
      topicFullParticipation_data,
      topicSpringExpert_data,
    ]: {
      data: { elemListDetail: TopicElemDetail[] };
    }[] = await Promise.all([
      FServiceAPI.Activity.getTopicInfo({
        code: '00001',
      }),
      FServiceAPI.Activity.getTopicInfo({
        code: '00002',
      }),
      FServiceAPI.Activity.getTopicInfo({
        code: '00003',
      }),
      FServiceAPI.Activity.getTopicInfo({
        code: '00004',
      }),
      FServiceAPI.Activity.getTopicInfo({
        code: '00005',
      }),
      FServiceAPI.Activity.getTopicInfo({
        code: '00006',
      }),
      FServiceAPI.Activity.getTopicInfo({
        code: '00007',
      }),
      FServiceAPI.Activity.getTopicInfo({
        code: '00008',
      }),
      FServiceAPI.Activity.getTopicInfo({
        code: '00009',
      }),
      FServiceAPI.Activity.getTopicInfo({
        code: '000010',
      }),
    ]);

    const allUserIDs = new Set<number>();
    topic1_data.data.elemListDetail.forEach((ed) => {
      allUserIDs.add(ed.userId);
    });
    topic2_data.data.elemListDetail.forEach((ed) => {
      allUserIDs.add(ed.userId);
    });
    topic3_data.data.elemListDetail.forEach((ed) => {
      allUserIDs.add(ed.userId);
    });
    topic4_data.data.elemListDetail.forEach((ed) => {
      allUserIDs.add(ed.userId);
    });
    topic5_data.data.elemListDetail.forEach((ed) => {
      allUserIDs.add(ed.userId);
    });
    topic6_data.data.elemListDetail.forEach((ed) => {
      allUserIDs.add(ed.userId);
    });
    const allUserIDsArray = Array.from(allUserIDs);

    const {
      data,
    }: {
      data: {
        userId: number;
        data: {
          capsuleType: 1 | 2 | 3;
          imgUrl: string;
          name: string;
        };
      }[];
    } = await FServiceAPI.Activity.getMaterialsByUserIds({
      userIds: allUserIDsArray,
    });

    const work1 = topic1_data.data.elemListDetail.find((ed) => !ed.resourceType.includes('矢量图'));
    const keepsake1 = topic1_data.data.elemListDetail.find((ed) =>
      ed.resourceType.includes('矢量图'),
    );

    const work3 = topic3_data.data.elemListDetail.find((ed) => !ed.resourceType.includes('矢量图'));
    const keepsake3 = topic3_data.data.elemListDetail.find((ed) =>
      ed.resourceType.includes('矢量图'),
    );
    const work5 = topic5_data.data.elemListDetail.find((ed) => !ed.resourceType.includes('矢量图'));
    set$topicResults({
      topic1: {
        avatar: FUtil.Domain.IMAGE_ORIGIN + `/avatar/${work1?.userId}`,
        username: work1?.username || '',
        work: {
          resourceID: work1?.resourceId || '',
          resourceCover: work1?.coverImages[0] || '',
          resourceTitle: work1?.resourceTitle || '',
          materials:
            data
              .filter((d) => d.userId === work1?.userId && d.data.capsuleType === 1)
              ?.map((d) => d.data.name) || [],
        },
        keepsake: {
          resourceID: keepsake1?.resourceId || '',
          resourceCover: keepsake1?.coverImages[0] || '',
          resourceTitle: keepsake1?.resourceTitle || '',
          downloadURL:
            FUtil.Format.completeUrlByDomain('api') +
            `/v2/resources/${keepsake1?.resourceId}/versions/${keepsake1?.latestVersion}/download`,
        },
      },
      topic2: topic2_data.data.elemListDetail.map((ed) => {
        return {
          resourceID: ed.resourceId,
          resourceCover: ed.coverImages[0],
          resourceTitle: ed.resourceTitle,
          materials:
            data
              .filter((d) => d.userId === ed.userId && d.data.capsuleType === 1)
              ?.map((d) => d.data.name) || [],
          avatar: FUtil.Domain.IMAGE_ORIGIN + `/avatar/${ed.userId}`,
          username: ed.username || '',
        };
      }),
      topic3: {
        avatar: FUtil.Domain.IMAGE_ORIGIN + `/avatar/${work3?.userId}`,
        username: work3?.username || '',
        work: {
          resourceID: work3?.resourceId || '',
          resourceCover: work3?.coverImages[0] || '',
          resourceTitle: work3?.resourceTitle || '',
          materials:
            data
              .filter((d) => d.userId === work3?.userId && d.data.capsuleType === 2)
              ?.map((d) => d.data.name) || [],
        },
        keepsake: {
          resourceID: keepsake3?.resourceId || '',
          resourceCover: keepsake3?.coverImages[0] || '',
          resourceTitle: keepsake3?.resourceTitle || '',
          downloadURL:
            FUtil.Format.completeUrlByDomain('api') +
            `/v2/resources/${keepsake3?.resourceId}/versions/${keepsake3?.latestVersion}/download`,
        },
      },
      topic4: topic4_data.data.elemListDetail.map((ed) => {
        return {
          resourceID: ed.resourceId,
          resourceCover: ed.coverImages[0],
          resourceTitle: ed.resourceTitle,
          materials:
            data
              .filter((d) => d.userId === ed.userId && d.data.capsuleType === 2)
              ?.map((d) => d.data.name) || [],
          avatar: FUtil.Domain.IMAGE_ORIGIN + `/avatar/${ed.userId}`,
          username: ed.username || '',
        };
      }),
      topic5: {
        avatar: FUtil.Domain.IMAGE_ORIGIN + `/avatar/${work5?.userId}`,
        username: work5?.username || '',
        work: {
          resourceID: work5?.resourceId || '',
          resourceCover: work5?.coverImages[0] || '',
          resourceTitle: work5?.resourceTitle || '',
          materials:
            data
              .filter((d) => d.userId === work5?.userId && d.data.capsuleType === 3)
              ?.map((d) => d.data.name) || [],
        },
      },
      topic6: topic6_data?.data?.elemListDetail?.map((ed) => {
        return {
          resourceID: ed.resourceId,
          resourceCover: ed.coverImages[0],
          resourceTitle: ed.resourceTitle,
          materials:
            data
              .filter((d) => d.userId === ed.userId && d.data.capsuleType === 3)
              ?.map((d) => d.data.name) || [],
          avatar: FUtil.Domain.IMAGE_ORIGIN + `/avatar/${ed.userId}`,
          username: ed.username || '',
        };
      }),
    });

    const mapElemToWinnerResource = (ed: TopicElemDetail): WinnerAnnouncementResourceItem => ({
      resourceID: ed.resourceId,
      resourceCover: ed.coverImages?.[0] || '',
      resourceTitle: ed.resourceTitle || ed.resourceName || '',
      avatar: FUtil.Domain.IMAGE_ORIGIN + `/avatar/${ed.userId}`,
      username: ed.username || '',
    });

    set$winnerAnnouncement({
      bestCreative: (topicBestCreative_data?.data?.elemListDetail ?? [])
        .slice(0, 3)
        .map(mapElemToWinnerResource),
      excellent: (topicExcellent_data?.data?.elemListDetail ?? [])
        .slice(0, 9)
        .map(mapElemToWinnerResource),
      fullParticipationUsernames: (topicFullParticipation_data?.data?.elemListDetail ?? []).map(
        (ed) => ed.username || '',
      ),
      springExpertUsernames: (topicSpringExpert_data?.data?.elemListDetail ?? []).map(
        (ed) => ed.username || '',
      ),
    });
  });

  function commitWorks() {
    if (!get$isLogined()) {
      self.location.replace(
        FUtil.Format.completeUrlByDomain('user') +
          FUtil.LinkTo.login({
            goTo: self.location.href,
          }),
      );
      return;
    }
    if (!get$isRegister()) {
      // fCenterMessage({ message: '此活动仅对内测用户开放!' });
      self.open(FUtil.Format.completeUrlByDomain('console') + FUtil.LinkTo.invitation());
      return;
    }
    self.open(FUtil.Format.completeUrlByDomain('console') + FUtil.LinkTo.resourceCreatorEntry());
  }

  AHooks.useMount(async () => {
    if (FUtil.Tool.getUserIDByCookies() === -1) {
      return;
    }
    // const {
    //   data,
    // }: {
    //   data: {
    //     completionTime: number;
    //   }[];
    // } = await FServiceAPI.Activity.statisticTaskRecords({
    //   codes: ['TS001206', 'TS001207', 'TS001208', 'TS001209', 'TS0012010'],
    //   startTime: get$collectTime().stage1Start.format('YYYY-MM-DD HH:mm:ss'),
    // });
    const {
      data,
    }: {
      data: {
        status: 1 | 2 | 3;
      };
    } = await FServiceAPI.Activity.getRewardRecordInfo({
      rewardConfigCode: 'RS0002607',
    });
    // console.log(data, 'data890i/oewjfsdlkfjlsdkfjlkj');
    // 是否全程参与
    set$isAllParticipate(data.status === 3);
  });

  AHooks.useMount(async () => {
    if (FUtil.Tool.getUserIDByCookies() === -1) {
      return;
    }
    // const {
    //   data,
    // }: {
    //   data: {
    //     completionTime: number;
    //   }[];
    // } = await FServiceAPI.Activity.statisticTaskRecords({
    //   codes: ['TS001201', 'TS001212'],
    //   startTime: get$collectTime().stage1Start.format('YYYY-MM-DD HH:mm:ss'),
    // });
    const {
      data,
    }: {
      data: {
        status: 1 | 2 | 3;
      };
    } = await FServiceAPI.Activity.getRewardRecordInfo({
      rewardConfigCode: 'RS0002608',
    });
    set$hasSpringFestivalJoyPrize(data.status === 3);
  });

  return (
    <>
      <div className={styles.container}>
        {/* 福字底纹背景 */}
        {/* <div className={styles.fuPatternBg}>
          <img src={imgFuPattern} alt='' />
        </div> */}

        {/* Banner */}
        <div className={styles.banner}>
          <img src={imgBanner} alt='' />
        </div>

        {/* 活动介绍 */}
        <div className={styles.section}>
          <div className={styles.sectionTitle}>
            <div className={styles.titleLeft}></div>
            <div className={styles.titleCenter}>
              {/* <span>活动介绍</span> */}
              <img src={img_title_activity_about} style={{ height: 104 }} alt='活动介绍' />
            </div>
            <div className={styles.titleRight}></div>
          </div>

          {/* 活动时间 */}
          <div className={styles.activityTime}>
            <div className={styles.activityTimeTitle}>
              {/* 活动时间 */}
              <img
                ref={ref_content1}
                src={img_activity_time}
                style={{ width: 200 }}
                alt='活动时间'
              />
            </div>
            <div className={styles.timeCards}>
              <div className={styles.timeCard}>
                <div className={styles.timeCardTitle}>
                  <div className={styles.charBox}>
                    <div className={styles.charInner}>
                      <span>活</span>
                    </div>
                  </div>
                  <div className={styles.charBox}>
                    <div className={styles.charInner}>
                      <span>动</span>
                    </div>
                  </div>
                  <div className={styles.charBox}>
                    <div className={styles.charInner}>
                      <span>开</span>
                    </div>
                  </div>
                  <div className={styles.charBox}>
                    <div className={styles.charInner}>
                      <span>启</span>
                    </div>
                  </div>
                </div>
                <div className={styles.timeText}>
                  {/* 2025-12-XX 00:00 */}
                  {activityDetailsPage.startTime?.format('YYYY-MM-DD HH:mm') || 'YYYY-MM-DD HH:mm'}
                </div>
              </div>
              <div className={styles.timeCard}>
                <div className={styles.timeCardTitle}>
                  <div className={styles.charBox}>
                    <div className={styles.charInner}>
                      <span>活</span>
                    </div>
                  </div>
                  <div className={styles.charBox}>
                    <div className={styles.charInner}>
                      <span>动</span>
                    </div>
                  </div>
                  <div className={styles.charBox}>
                    <div className={styles.charInner}>
                      <span>结</span>
                    </div>
                  </div>
                  <div className={styles.charBox}>
                    <div className={styles.charInner}>
                      <span>束</span>
                    </div>
                  </div>
                </div>
                <div className={styles.timeText}>
                  {/* 2026-01-XX 00:00 */}
                  {activityDetailsPage.endTime?.format('YYYY-MM-DD HH:mm') || 'YYYY-MM-DD HH:mm'}
                </div>
              </div>
              <div className={styles.timeCard}>
                <div className={styles.timeCardTitle}>
                  <div className={styles.charBox}>
                    <div className={styles.charInner}>
                      <span>获</span>
                    </div>
                  </div>
                  <div className={styles.charBox}>
                    <div className={styles.charInner}>
                      <span>奖</span>
                    </div>
                  </div>
                  <div className={styles.charBox}>
                    <div className={styles.charInner}>
                      <span>公</span>
                    </div>
                  </div>
                  <div className={styles.charBox}>
                    <div className={styles.charInner}>
                      <span>示</span>
                    </div>
                  </div>
                </div>
                <div className={styles.timeText}>
                  {/* 2026-02-XX 00:00 */}
                  {activityDetailsPage.announceTime?.format('YYYY-MM-DD HH:mm') ||
                    'YYYY-MM-DD HH:mm'}
                </div>
              </div>
            </div>
          </div>

          {/* 内测资格 */}
          <div className={styles.qualification}>
            <div className={styles.qualificationTitle}>
              {/* 获得内测资格 */}
              <img src={img_get_alpha_test} style={{ width: 310 }} alt='获得内测资格' />
            </div>
            <div className={styles.qualificationContent}>
              <div className={styles.qualificationItem}>
                <div className={styles.qualificationNumber}>1</div>
                <div className={styles.qualificationText}>
                  参与活动需先获取内测资格，
                  <br />
                  已获资格者可直通活动。
                </div>
              </div>
              <div className={styles.qualificationItem}>
                <div className={styles.qualificationNumber}>2</div>
                <div className={styles.qualificationText}>
                  为确保最完整的功体验，
                  <br />
                  推荐使用电脑端访问Freelog网页版。
                </div>
              </div>
            </div>
            <div className={styles.qualificationButtons}>
              {!$isRegister && (
                <div
                  className={styles.qualificationButton}
                  onClick={async () => {
                    const {
                      data,
                    }: {
                      data: {
                        userType: 0 | 1;
                      };
                    } = await FServiceAPI.User.currentUserInfo();

                    if (FUtil.Tool.getUserIDByCookies() === -1) {
                      return;
                    }

                    self.open(
                      FUtil.Format.completeUrlByDomain('console') +
                        FUtil.LinkTo.invitation() +
                        '?type=apply',
                    );
                  }}
                >
                  提交内测申请
                </div>
              )}

              {$isRegister && (
                <div className={`${styles.qualificationButton} ${styles.disabled}`}>已获资格</div>
              )}
            </div>
          </div>

          <div className={styles.mechanism}>
            <div className={styles.mechanismTitle}>
              <img
                ref={ref_content2}
                src={img_activity_mechanism}
                style={{ width: 205 }}
                alt='活动机制'
              />
            </div>

            {/* 创作主题要求 */}
            <div className={[styles.mechanismCard, styles.contentBg].join(' ')}>
              <div className={styles.mechanismCardTitle}>
                <div className={styles.charBox}>
                  <div className={styles.charInner}>
                    <span>创</span>
                  </div>
                </div>
                <div className={styles.charBox}>
                  <div className={styles.charInner}>
                    <span>作</span>
                  </div>
                </div>
                <div className={styles.charBox}>
                  <div className={styles.charInner}>
                    <span>主</span>
                  </div>
                </div>
                <div className={styles.charBox}>
                  <div className={styles.charInner}>
                    <span>题</span>
                  </div>
                </div>
                <div className={styles.charBox}>
                  <div className={styles.charInner}>
                    <span>要</span>
                  </div>
                </div>
                <div className={styles.charBox}>
                  <div className={styles.charInner}>
                    <span>求</span>
                  </div>
                </div>
              </div>
              <div className={styles.mechanismCardContent}>
                <div className={styles.mechanismItem}>
                  <div className={styles.mechanismItemTitle}>核心主题</div>
                  <div className={styles.mechanismItemText}>
                    作品须围绕 传统新春 或 2026丙午马年 主题展开
                  </div>
                </div>
                <div className={styles.mechanismItem}>
                  <div className={styles.mechanismItemTitle}>阶段主题</div>
                  <div className={styles.mechanismItemText}>
                    每轮设有特定主题，插画内容须符合该阶段主题要求
                  </div>
                </div>
                <div className={styles.mechanismItem}>
                  <div className={styles.mechanismItemTitle}>随机盲盒</div>
                  <div className={styles.mechanismItemText}>
                    每轮须抽取随机盲盒素材，并结合个人风格进行融合创作
                  </div>
                </div>
              </div>
            </div>

            {/* 信物接龙机制 */}
            <div className={[styles.mechanismCard, styles.contentBg].join(' ')}>
              <div className={styles.mechanismCardTitle}>
                <div className={styles.charBox}>
                  <div className={styles.charInner}>
                    <span>信</span>
                  </div>
                </div>
                <div className={styles.charBox}>
                  <div className={styles.charInner}>
                    <span>物</span>
                  </div>
                </div>
                <div className={styles.charBox}>
                  <div className={styles.charInner}>
                    <span>接</span>
                  </div>
                </div>
                <div className={styles.charBox}>
                  <div className={styles.charInner}>
                    <span>龙</span>
                  </div>
                </div>
                <div className={styles.charBox}>
                  <div className={styles.charInner}>
                    <span>机</span>
                  </div>
                </div>
                <div className={styles.charBox}>
                  <div className={styles.charInner}>
                    <span>制</span>
                  </div>
                </div>
              </div>
              <div className={styles.mechanismCardContent}>
                <div className={styles.mechanismItem}>
                  <div className={styles.mechanismItemTitle}>指定</div>
                  <div className={styles.mechanismItemText}>
                    {/* 前两轮创作者须从本人插画中指定一个图形元素（如角色、道具）作为"信物" */}
                    前两轮创作者须在投稿的插画中<strong>指定</strong>
                    一个图形元素（如角色、道具）作为<strong>“信物”</strong>
                  </div>
                </div>
                <div className={styles.mechanismItem}>
                  <div className={styles.mechanismItemTitle}>传递</div>
                  <div className={styles.mechanismItemText}>
                    每轮评选出1个最佳作品，其"信物"将自动成为下一轮所有创作者必须承接的指定素材
                  </div>
                </div>
                <div className={styles.mechanismItem}>
                  <div className={styles.mechanismItemTitle}>承接</div>
                  <div className={styles.mechanismItemText}>
                    后续轮次创作者须将所承接的"信物"融入自身插画创作中
                  </div>
                </div>
              </div>
            </div>

            {/* 作品提交要求 */}
            <div
              className={[styles.mechanismCard, styles.contentBg, styles.submitRequirement].join(
                ' ',
              )}
            >
              <div className={styles.mechanismCardTitle}>
                <div className={styles.charBox}>
                  <div className={styles.charInner}>
                    <span>作</span>
                  </div>
                </div>
                <div className={styles.charBox}>
                  <div className={styles.charInner}>
                    <span>品</span>
                  </div>
                </div>
                <div className={styles.charBox}>
                  <div className={styles.charInner}>
                    <span>提</span>
                  </div>
                </div>
                <div className={styles.charBox}>
                  <div className={styles.charInner}>
                    <span>交</span>
                  </div>
                </div>
                <div className={styles.charBox}>
                  <div className={styles.charInner}>
                    <span>要</span>
                  </div>
                </div>
                <div className={styles.charBox}>
                  <div className={styles.charInner}>
                    <span>求</span>
                  </div>
                </div>
              </div>
              <div className={styles.submitRequirementHeader}>
                所有参与者均须提交<strong>完整插画作品</strong>
              </div>
              <div className={styles.mechanismCardContent}>
                <div className={styles.mechanismItem}>
                  <div className={styles.mechanismItemTitle}>标题要求</div>
                  <div className={styles.mechanismItemText}>
                    完整插画须以“第x轮 - 作品主题”格式命名
                  </div>
                </div>
                <div className={styles.mechanismItem}>
                  <div className={styles.mechanismItemTitle}>格式要求</div>
                  <div className={styles.mechanismItemText}>JPEG/PNG格式，分辨率≥72dpi</div>
                </div>
                <div className={styles.mechanismItem}>
                  <div className={styles.mechanismItemTitle}>标签要求</div>
                  <div className={styles.mechanismItemText}>
                    添加专属活动标签
                    <br />
                    <FComponentsLib.FTextBtn
                      onClick={() => {
                        copy('#2026"新年信物 • 插画接龙"创作赛#', {
                          format: 'text/plain',
                        });
                        fCenterMessage({ message: '复制成功' });
                      }}
                      style={{ fontSize: 16, lineHeight: '24px' }}
                    >
                      #2026"新年信物 • 插画接龙"创作赛#
                    </FComponentsLib.FTextBtn>
                  </div>
                </div>
              </div>
              <div className={styles.submitRequirementFooter}>
                <div className={styles.submitRequirementFooterTitle}>此外</div>
                <div className={styles.mechanismCardContent}>
                  <div className={styles.mechanismItem}>
                    <div className={styles.mechanismItemTitle}>信物指定者</div>
                    <div className={styles.mechanismItemText}>
                      {/* 须一并提交该信物的 矢量文件 */}
                      须一并提交该信物的 矢量文件（如.ai/.eps/.svg/.pdf等），并确保标题按“第x轮 -
                      作品主题 - 信物”格式命名
                    </div>
                  </div>
                  <div className={styles.mechanismItem}>
                    <div className={styles.mechanismItemTitle}>信物接收者</div>
                    <div className={styles.mechanismItemText}>
                      须将所承接的"信物"，作为本作品的{' '}
                      <FComponentsLib.FTextBtn
                        style={{ fontSize: 16, lineHeight: '24px', display: 'inline-block' }}
                        onClick={() => {
                          self.open(
                            'https://freelog3.freelog.cn/?theme=%2Freader%3Fid%25M262d0d04f456ff0002e329537%25M1title%25M22.%E5%A6%82%E4%BD%95%E6%B7%BB%E5%8A%A0%E4%BE%9D%E8%B5%96%E5%A3%B0%E6%98%8E&w06c513=%2F',
                          );
                        }}
                        type='primary'
                      >
                        依赖资源
                      </FComponentsLib.FTextBtn>{' '}
                      一并提交
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* 参与方式 */}
        <div className={styles.section} ref={ref_content3}>
          <div className={styles.sectionTitle}>
            {/* <div className={styles.titleLeft}></div> */}
            <div className={styles.titleCenter}>
              {/* <span>新年信物 • 插画接龙</span> */}
              <img
                src={img_title_new_year_authenticate}
                style={{ height: 104 }}
                alt='新年信物 • 插画接龙'
              />
            </div>
            {/* <div className={styles.titleRight}></div> */}
          </div>

          {/* 第一阶段 */}
          <div className={styles.stage}>
            <div className={styles.stageTitle}>
              {/* 第1阶段：盼新春 - 归家与筹备 */}
              <img src={img_stage_1} style={{ width: 580 }} alt='第1阶段：盼新春 - 归家与筹备' />
            </div>
            <div className={styles.stageTime}>
              {/* <span>2025-xx-xx 00:00:00 ~ xx-xx 23:59:59</span> */}
              <span>
                {$collectTime.stage1Start?.format('YYYY-MM-DD HH:mm')} ~{' '}
                {$collectTime.stage1End?.format('YYYY-MM-DD HH:mm')}
              </span>
              <div className={styles.stageStatus}>
                {$collectTimeStatus.stage1 === 'notStart' && (
                  <img src={img_not_start} style={{ height: 38 }} alt='未开始' />
                )}
                {$collectTimeStatus.stage1 === 'inProgress' && (
                  <img src={img_in_progress} style={{ height: 38 }} alt='进行中' />
                )}
                {$collectTimeStatus.stage1 === 'finished' && (
                  <img src={img_have_finished} style={{ height: 38 }} alt='已结束' />
                )}
              </div>
            </div>

            {/* 参与要求 */}
            <div className={[styles.stageRequirement, styles.contentBg].join(' ')}>
              <div className={styles.stageRequirementTitle}>
                <div className={styles.charBox}>
                  <div className={styles.charInner}>
                    <span>本</span>
                  </div>
                </div>
                <div className={styles.charBox}>
                  <div className={styles.charInner}>
                    <span>赛</span>
                  </div>
                </div>
                <div className={styles.charBox}>
                  <div className={styles.charInner}>
                    <span>段</span>
                  </div>
                </div>
                <div className={styles.charBox}>
                  <div className={styles.charInner}>
                    <span>参</span>
                  </div>
                </div>
                <div className={styles.charBox}>
                  <div className={styles.charInner}>
                    <span>与</span>
                  </div>
                </div>
                <div className={styles.charBox}>
                  <div className={styles.charInner}>
                    <span>要</span>
                  </div>
                </div>
                <div className={styles.charBox}>
                  <div className={styles.charInner}>
                    <span>求</span>
                  </div>
                </div>
              </div>
              <div className={styles.stageRequirementContent}>
                <div className={styles.stageRequirementItem}>
                  <div className={styles.stageRequirementItemTitle}>素材要求</div>
                  <div className={styles.stageRequirementItemText}>
                    本轮您需要将抽取的3个盲盒融入插画创作
                  </div>
                </div>
                <div className={styles.stageRequirementItem}>
                  <div className={styles.stageRequirementItemTitle}>指定信物</div>
                  <div className={styles.stageRequirementItemText}>
                    {/* 从您的画作中，<strong>指定一个图形元素</strong>（如角色、道具等）作为
                    <strong>"信物"</strong> */}
                    从您投稿的画作中，<strong>指定一个图形元素</strong>（如角色、道具等）作为
                    <strong>“信物”</strong>
                  </div>
                </div>
                <div className={styles.stageRequirementItem}>
                  <div className={styles.stageRequirementItemTitle}>提交成果</div>
                  <div className={styles.stageRequirementItemText}>
                    {/* 提交插画作品时，<strong>须一并提交该"信物"</strong>的<strong>矢量素材</strong> */}
                    A · 提交以“第1轮 - 作品主题”格式命名的完整插画作品；
                    <br />B · 提交以“第1轮 - 作品主题 - 信物”格式命名的“信物”矢量文件。
                  </div>
                </div>
              </div>
            </div>
            {($collectTimeStatus.stage1 === 'inProgress' ||
              ($collectTimeStatus.stage1 === 'finished' && $luckyBox1Results.length > 0)) && (
              <div className={styles.extractMaterial}>
                <img src={img_extract_material} style={{ width: 244 }} alt='抽取本轮盲盒素材' />
                <div style={{ height: 10 }} />
                <LuckyBox
                  stage={1}
                  showBox={$luckyBox1Results.length === 0}
                  // disabled={$collectTimeStatus.stage1 === 'notStart'}
                  onResult={(results) => {
                    set$luckyBox1Results(results);
                  }}
                />
                {$luckyBox1Results.length > 0 && (
                  <div
                    style={{
                      display: 'flex',
                      gap: 50,
                      justifyContent: 'center',
                      alignItems: 'center',
                    }}
                  >
                    {$luckyBox1Results.map((result, index) => (
                      <div
                        key={index}
                        style={{
                          display: 'flex',
                          flexDirection: 'column',
                          alignItems: 'center',
                          gap: 20,
                        }}
                      >
                        <img
                          key={index}
                          src={result.imgUrl}
                          alt={result.name}
                          style={{ width: 240, height: 240, display: 'block' }}
                        />
                        <div style={{ fontSize: 16, color: '#000' }}>{result.name}</div>
                      </div>
                    ))}
                  </div>
                )}
                <div style={{ height: 20 }} />
                {$luckyBox1Results.length > 0 ? (
                  <div className={styles.extractMaterialText}>抽取完成</div>
                ) : (
                  <div className={styles.extractMaterialText}>点击上方礼盒抽取素材</div>
                )}
                <div style={{ height: 15 }} />
                <div className={styles.extractMaterialText2}>
                  请将抽取的3个盲盒素材，以个人风格融入插画，而非直接使用参考图形
                </div>
                <div style={{ height: 20 }} />
                <div className={styles.qualificationButtons}>
                  <div
                    className={[
                      styles.qualificationButton,
                      $collectTimeStatus.stage1 !== 'inProgress' ? styles.disabled : '',
                    ].join(' ')}
                    onClick={() => {
                      if (get$collectTimeStatus().stage1 !== 'inProgress') {
                        return;
                      }
                      commitWorks();
                    }}
                  >
                    提交作品
                  </div>
                </div>
              </div>
            )}

            {$momentTime.isBefore($collectTime.stage1Announce) && (
              <div className={styles.stageResult}>
                第一轮评选结果将于 {$collectTime.stage1Announce?.format('YYYY-MM-DD HH:mm')} 公开
              </div>
            )}
            {$momentTime.isAfter($collectTime.stage1Announce) && (
              <div className={styles.stageResultBox}>
                <div className={styles.stageResult}>
                  {/* 第一轮评选结果将于 2025-xx-xx 00:00:00 公开 */}
                  第一轮评选结果 {$collectTime.stage1Announce?.format('YYYY-MM-DD HH:mm')} 公开
                </div>
                <div style={{ height: 10 }} />
                <div className={styles.resultTitle}>最佳创意作品</div>
                <div style={{ height: 20 }} />

                <div className={[styles.bestWorkContent, styles.contentBg].join(' ')}>
                  {/* 作者卡片 */}
                  <div className={styles.authorCard}>
                    <div className={styles.authorCardTitle}>作者</div>
                    <div className={styles.authorCardAvatar}>
                      <img src={$topicResults?.topic1?.avatar} alt='作者头像' />
                    </div>
                    <div className={styles.authorCardName}>{$topicResults?.topic1?.username}</div>
                    <div style={{ height: 20 }} />
                  </div>

                  {/* 资源卡片 */}
                  <div
                    className={styles.resourceCardBest}
                    // onClick={() => {
                    //   window.open(
                    //     FUtil.Format.completeUrlByDomain('console') +
                    //       FUtil.LinkTo.resourceDetails({
                    //         resourceID: get$topicResults()?.topic1?.work?.resourceID || '',
                    //       }),
                    //   );
                    // }}
                  >
                    <div className={styles.resourceCardBestTitle}>参赛作品</div>
                    <div
                      className={styles.resourceCardBestCover}
                      style={{
                        backgroundImage:
                          'url(' + ($topicResults?.topic1?.work?.resourceCover || '') + ')',
                      }}
                      onClick={() => {
                        openResourceDetails($topicResults?.topic1?.work?.resourceID || '');
                      }}
                    >
                      <div />
                      <article
                        style={{
                          backgroundImage:
                            'url(' + ($topicResults?.topic1?.work?.resourceCover || '') + ')',
                        }}
                      />
                    </div>
                    <div
                      className={styles.resourceCardBestName}
                      onClick={() => {
                        openResourceDetails($topicResults?.topic1?.work?.resourceID || '');
                      }}
                    >
                      {$topicResults?.topic1?.work?.resourceTitle}
                    </div>
                    <div className={styles.resourceCardBestMaterials}>
                      <span>盲盒素材：</span>
                      {$topicResults?.topic1?.work?.materials.map((material, index) => {
                        return <span key={index}>{material}</span>;
                      })}
                    </div>
                  </div>

                  {/* 信物卡片 */}
                  <div className={styles.artifactCard}>
                    <div className={styles.artifactCardTitle}>信物</div>
                    <div
                      className={styles.artifactCardCover}
                      onClick={() => {
                        openResourceDetails($topicResults?.topic1?.keepsake?.resourceID || '');
                      }}
                    >
                      <img src={$topicResults?.topic1?.keepsake?.resourceCover} alt='信物封面' />
                    </div>
                    <div
                      className={styles.artifactCardName}
                      onClick={() => {
                        openResourceDetails($topicResults?.topic1?.keepsake?.resourceID || '');
                      }}
                    >
                      {$topicResults?.topic1?.keepsake?.resourceTitle}
                    </div>
                    <div
                      className={styles.artifactCardButton}
                      onClick={() => {
                        window.open($topicResults?.topic1?.keepsake?.downloadURL, '_self');
                      }}
                    >
                      下载 "信物" 素材
                    </div>
                  </div>
                </div>

                <div
                  style={{
                    height: 30,
                    display: ($topicResults?.topic2?.length ?? 0) > 0 ? 'block' : 'none',
                  }}
                />
                <div
                  className={styles.resultTitle}
                  style={{ display: ($topicResults?.topic2?.length ?? 0) > 0 ? 'block' : 'none' }}
                >
                  优秀入围作品
                </div>
                <div
                  style={{
                    height: 20,
                    display: ($topicResults?.topic2?.length ?? 0) > 0 ? 'block' : 'none',
                  }}
                />

                <div
                  className={[styles.excellentWorks, styles.contentBg].join(' ')}
                  style={{ display: ($topicResults?.topic2?.length ?? 0) > 0 ? 'flex' : 'none' }}
                >
                  {$topicResults?.topic2.map((topic) => {
                    return (
                      <div
                        className={styles.excellentResourceCard}
                        key={topic.resourceID}
                        onClick={() => {
                          // window.open(
                          //   FUtil.Format.completeUrlByDomain('console') +
                          //     FUtil.LinkTo.resourceDetails({
                          //       resourceID: topic.resourceID,
                          //     }),
                          // );
                        }}
                      >
                        <div
                          className={styles.excellentResourceCover}
                          style={{
                            backgroundImage: 'url(' + (topic.resourceCover || '') + ')',
                          }}
                          onClick={() => {
                            openResourceDetails(topic.resourceID);
                          }}
                        >
                          <div />
                          <article
                            style={{
                              backgroundImage: 'url(' + (topic.resourceCover || '') + ')',
                            }}
                          />
                        </div>
                        <div
                          className={styles.excellentResourceName}
                          onClick={() => {
                            openResourceDetails(topic.resourceID);
                          }}
                        >
                          <span className={styles.excellentResourceNameText}>
                            {topic.resourceTitle}
                          </span>
                        </div>
                        <div className={styles.excellentResourceAuthor}>
                          <div className={styles.excellentAuthorAvatar}>
                            <img src={topic.avatar} alt='作者头像1' />
                          </div>
                          <span className={styles.excellentAuthorName}>{topic.username}</span>
                        </div>
                        <div className={styles.excellentMaterialInfo}>
                          <span>盲盒素材：</span>
                          {topic.materials.map((material, index) => {
                            return <span key={index}>{material}</span>;
                          })}
                        </div>
                      </div>
                    );
                  })}

                  {/* 资源卡片2 */}
                  {/* <div className={styles.excellentResourceCard}>
                    <div className={styles.excellentResourceCover}>
                      <img src={img_resource_cover_2} alt='资源封面2' />
                    </div>
                    <div className={styles.excellentResourceName}>
                      <span className={styles.excellentResourceNameText}>
                        资源名称悬停显示下划线
                      </span>
                    </div>
                    <div className={styles.excellentResourceAuthor}>
                      <div className={styles.excellentAuthorAvatar}>
                        <img src={img_author_avatar_2} alt='作者头像2' />
                      </div>
                      <span className={styles.excellentAuthorName}>username</span>
                    </div>
                    <div className={styles.excellentMaterialInfo}>
                      <span>盲盒素材：</span>
                      <span>xxxx</span>
                      <span>xxxx</span>
                      <span>xxxx</span>
                    </div>
                  </div> */}

                  {/* 资源卡片3 */}
                  {/* <div className={styles.excellentResourceCard}>
                    <div className={styles.excellentResourceCover}>
                      <img src={img_resource_cover_3} alt='资源封面3' />
                    </div>
                    <div className={styles.excellentResourceName}>
                      <span className={styles.excellentResourceNameText}>
                        资源名称悬停显示下划线
                      </span>
                    </div>
                    <div className={styles.excellentResourceAuthor}>
                      <div className={styles.excellentAuthorAvatar}>
                        <img src={img_author_avatar_3} alt='作者头像3' />
                      </div>
                      <span className={styles.excellentAuthorName}>username</span>
                    </div>
                    <div className={styles.excellentMaterialInfo}>
                      <span>盲盒素材：</span>
                      <span>xxxx</span>
                      <span>xxxx</span>
                      <span>xxxx</span>
                    </div>
                  </div> */}
                </div>
              </div>
            )}
          </div>

          {/* 第二阶段 */}
          <div className={styles.stage}>
            <div className={styles.stageTitle}>
              <img src={img_stage_2} style={{ width: 580 }} alt='第2阶段：贺新春——欢庆与热闹' />
            </div>
            <div className={styles.stageTime}>
              {/* <span>2025-xx-xx 00:00:00 ~ xx-xx 23:59:59</span> */}
              <span>
                {$collectTime.stage2Start?.format('YYYY-MM-DD HH:mm')} ~{' '}
                {$collectTime.stage2End?.format('YYYY-MM-DD HH:mm')}
              </span>
              <div className={styles.stageStatus}>
                {$collectTimeStatus.stage2 === 'notStart' && (
                  <img src={img_not_start} style={{ height: 38 }} alt='未开始' />
                )}
                {$collectTimeStatus.stage2 === 'inProgress' && (
                  <img src={img_in_progress} style={{ height: 38 }} alt='进行中' />
                )}
                {$collectTimeStatus.stage2 === 'finished' && (
                  <img src={img_have_finished} style={{ height: 38 }} alt='已结束' />
                )}
              </div>
            </div>

            {/* 参与要求 */}
            <div className={[styles.stageRequirement, styles.contentBg].join(' ')}>
              <div className={styles.stageRequirementTitle}>
                <div className={styles.charBox}>
                  <div className={styles.charInner}>
                    <span>本</span>
                  </div>
                </div>
                <div className={styles.charBox}>
                  <div className={styles.charInner}>
                    <span>赛</span>
                  </div>
                </div>
                <div className={styles.charBox}>
                  <div className={styles.charInner}>
                    <span>段</span>
                  </div>
                </div>
                <div className={styles.charBox}>
                  <div className={styles.charInner}>
                    <span>参</span>
                  </div>
                </div>
                <div className={styles.charBox}>
                  <div className={styles.charInner}>
                    <span>与</span>
                  </div>
                </div>
                <div className={styles.charBox}>
                  <div className={styles.charInner}>
                    <span>要</span>
                  </div>
                </div>
                <div className={styles.charBox}>
                  <div className={styles.charInner}>
                    <span>求</span>
                  </div>
                </div>
              </div>
              <div className={styles.stageRequirementContent}>
                <div className={styles.stageRequirementItem}>
                  <div className={styles.stageRequirementItemTitle}>素材要求</div>
                  <div className={styles.stageRequirementItemText}>
                    本轮您需要在插画中融入以下素材：
                  </div>
                  <div className={styles.stageRequirementItemText}>
                    <strong>A· 抽取的3个盲盒</strong>
                  </div>
                  <div className={styles.stageRequirementItemText}>
                    <strong>B · 第1轮公示中的“信物”</strong>
                  </div>
                </div>
                <div className={styles.stageRequirementItem}>
                  <div className={styles.stageRequirementItemTitle}>指定信物</div>
                  <div className={styles.stageRequirementItemText}>
                    {/* 从您的画作中，<strong>指定一个图形元素</strong>（如角色、道具等）作为
                    <strong>"信物"</strong> */}
                    从您投稿的画作中，<strong>指定一个图形元素</strong>（如角色、道具等）作为
                    <strong>“信物”</strong>
                  </div>
                </div>
                <div className={styles.stageRequirementItem}>
                  <div className={styles.stageRequirementItemTitle}>提交成果</div>
                  <div className={styles.stageRequirementItemText}>
                    A · 提交以“第2轮 - 作品主题”格式命名的完整插画作品，并将承接的“信物”添加为依赖；
                    <br />B · 提交以“第2轮 - 作品主题 - 信物”格式命名的“信物”矢量文件。
                  </div>
                  {/* <div className={styles.stageRequirementItemText}>提交完整插画作品时，还须：</div>
                  <div className={styles.stageRequirementItemText}>
                    <strong>A· 将您承接的“信物”添加为作品的依赖资源；</strong>
                  </div>
                  <div className={styles.stageRequirementItemText}>
                    <strong>B · 一并提交您指定的“信物”的矢量素材。</strong>
                  </div> */}
                </div>
              </div>
            </div>

            {($collectTimeStatus.stage2 === 'inProgress' ||
              ($collectTimeStatus.stage2 === 'finished' && $luckyBox2Results.length > 0)) && (
              <div className={styles.extractMaterial}>
                <img src={img_extract_material} style={{ width: 244 }} alt='抽取本轮盲盒素材' />
                <div style={{ height: 10 }} />
                <LuckyBox
                  stage={2}
                  showBox={$luckyBox2Results.length === 0}
                  // disabled={$collectTimeStatus.stage2 === 'notStart'}
                  onResult={(results) => {
                    set$luckyBox2Results(results);
                  }}
                />
                {$luckyBox2Results.length > 0 && (
                  <div
                    style={{
                      display: 'flex',
                      gap: 50,
                      justifyContent: 'center',
                      alignItems: 'center',
                    }}
                  >
                    {$luckyBox2Results.map((result, index) => (
                      <div
                        key={index}
                        style={{
                          display: 'flex',
                          flexDirection: 'column',
                          alignItems: 'center',
                          gap: 20,
                        }}
                      >
                        <img
                          key={index}
                          src={result.imgUrl}
                          alt={result.name}
                          style={{ width: 240, height: 240, display: 'block' }}
                        />
                        <div style={{ fontSize: 16, color: '#000' }}>{result.name}</div>
                      </div>
                    ))}
                  </div>
                )}
                <div style={{ height: 20 }} />
                {$luckyBox2Results.length > 0 ? (
                  <div className={styles.extractMaterialText}>抽取完成</div>
                ) : (
                  <div className={styles.extractMaterialText}>点击上方礼盒抽取素材</div>
                )}
                <div style={{ height: 15 }} />
                <div className={styles.extractMaterialText2}>
                  请将抽取的3个盲盒素材，以个人风格融入插画，而非直接使用参考图形
                </div>
                <div style={{ height: 20 }} />
                <div className={styles.qualificationButtons}>
                  <div
                    className={[
                      styles.qualificationButton,
                      $collectTimeStatus.stage2 !== 'inProgress' ? styles.disabled : '',
                    ].join(' ')}
                    onClick={() => {
                      if (get$collectTimeStatus().stage2 !== 'inProgress') {
                        return;
                      }
                      commitWorks();
                    }}
                  >
                    提交作品
                  </div>
                </div>
              </div>
            )}

            {$momentTime.isBefore($collectTime.stage2Announce) && (
              <div className={styles.stageResult}>
                第二轮评选结果将于 {$collectTime.stage2Announce?.format('YYYY-MM-DD HH:mm')} 公开
              </div>
            )}
            {$momentTime.isAfter($collectTime.stage2Announce) && (
              <div className={styles.stageResultBox}>
                <div className={styles.stageResult}>
                  第二轮评选结果 {$collectTime.stage2Announce?.format('YYYY-MM-DD HH:mm')}
                </div>
                <div style={{ height: 10 }} />
                <div className={styles.resultTitle}>最佳创意作品</div>
                <div style={{ height: 20 }} />

                <div className={[styles.bestWorkContent, styles.contentBg].join(' ')}>
                  {/* 作者卡片 */}
                  <div className={styles.authorCard}>
                    <div className={styles.authorCardTitle}>作者</div>
                    <div className={styles.authorCardAvatar}>
                      <img src={$topicResults?.topic3?.avatar} alt='作者头像' />
                    </div>
                    <div className={styles.authorCardName}>{$topicResults?.topic3?.username}</div>
                    <div style={{ height: 20 }} />
                  </div>

                  {/* 资源卡片 */}
                  <div
                    className={styles.resourceCardBest}
                    // onClick={() => {
                    // window.open(
                    //   FUtil.Format.completeUrlByDomain('console') +
                    //     FUtil.LinkTo.resourceDetails({
                    //       resourceID: get$topicResults()?.topic3?.work?.resourceID || '',
                    //     }),
                    // );
                    // }}
                  >
                    <div className={styles.resourceCardBestTitle}>参赛作品</div>
                    <div
                      className={styles.resourceCardBestCover}
                      style={{
                        backgroundImage:
                          'url(' + ($topicResults?.topic3?.work?.resourceCover || '') + ')',
                      }}
                      onClick={() => {
                        openResourceDetails($topicResults?.topic3?.work?.resourceID || '');
                      }}
                    >
                      <div />
                      <article
                        style={{
                          backgroundImage:
                            'url(' + ($topicResults?.topic3?.work?.resourceCover || '') + ')',
                        }}
                      />
                    </div>
                    <div
                      className={styles.resourceCardBestName}
                      onClick={() => {
                        openResourceDetails($topicResults?.topic3?.work?.resourceID || '');
                      }}
                    >
                      {$topicResults?.topic3?.work?.resourceTitle}
                    </div>
                    <div className={styles.resourceCardBestMaterials}>
                      <span>盲盒素材：</span>
                      {$topicResults?.topic3?.work?.materials.map((material, index) => {
                        return <span key={index}>{material}</span>;
                      })}
                    </div>
                  </div>

                  <div className={styles.artifactCard}>
                    <div className={styles.artifactCardTitle}>信物</div>
                    <div
                      className={styles.artifactCardCover}
                      onClick={() => {
                        openResourceDetails($topicResults?.topic3?.keepsake?.resourceID || '');
                      }}
                    >
                      <img src={$topicResults?.topic3?.keepsake?.resourceCover} alt='信物封面' />
                    </div>
                    <div
                      className={styles.artifactCardName}
                      onClick={() => {
                        openResourceDetails($topicResults?.topic3?.keepsake?.resourceID || '');
                      }}
                    >
                      {$topicResults?.topic3?.keepsake?.resourceTitle}
                    </div>
                    <div
                      className={styles.artifactCardButton}
                      onClick={() => {
                        window.open($topicResults?.topic3?.keepsake?.downloadURL, '_self');
                      }}
                    >
                      下载 "信物" 素材
                    </div>
                  </div>
                </div>

                <div
                  style={{
                    height: 30,
                    display: ($topicResults?.topic4?.length ?? 0) > 0 ? 'block' : 'none',
                  }}
                />
                <div
                  className={styles.resultTitle}
                  style={{ display: ($topicResults?.topic4?.length ?? 0) > 0 ? 'block' : 'none' }}
                >
                  优秀入围作品
                </div>
                <div
                  style={{
                    height: 20,
                    display: ($topicResults?.topic4?.length ?? 0) > 0 ? 'block' : 'none',
                  }}
                />

                <div
                  className={[styles.excellentWorks, styles.contentBg].join(' ')}
                  style={{ display: ($topicResults?.topic4?.length ?? 0) > 0 ? 'flex' : 'none' }}
                >
                  {$topicResults?.topic4.map((topic) => {
                    return (
                      <div
                        className={styles.excellentResourceCard}
                        key={topic.resourceID}
                        // onClick={() => {
                        // window.open(
                        //   FUtil.Format.completeUrlByDomain('console') +
                        //     FUtil.LinkTo.resourceDetails({
                        //       resourceID: topic.resourceID,
                        //     }),
                        // );
                        // }}
                      >
                        <div
                          className={styles.excellentResourceCover}
                          style={{
                            backgroundImage: 'url(' + (topic.resourceCover || '') + ')',
                          }}
                          onClick={() => {
                            openResourceDetails(topic.resourceID);
                          }}
                        >
                          <div />
                          <article
                            style={{
                              backgroundImage: 'url(' + (topic.resourceCover || '') + ')',
                            }}
                          />
                        </div>
                        <div
                          className={styles.excellentResourceName}
                          onClick={() => {
                            openResourceDetails(topic.resourceID);
                          }}
                        >
                          <span className={styles.excellentResourceNameText}>
                            {topic.resourceTitle}
                          </span>
                        </div>
                        <div className={styles.excellentResourceAuthor}>
                          <div className={styles.excellentAuthorAvatar}>
                            <img src={topic.avatar} alt='作者头像1' />
                          </div>
                          <span className={styles.excellentAuthorName}>{topic.username}</span>
                        </div>
                        <div className={styles.excellentMaterialInfo}>
                          <span>盲盒素材：</span>
                          {topic.materials.map((material, index) => {
                            return <span key={index}>{material}</span>;
                          })}
                        </div>
                      </div>
                    );
                  })}
                </div>
              </div>
            )}
          </div>

          {/* 第三阶段 */}
          <div className={styles.stage}>
            <div className={styles.stageTitle}>
              <img src={img_stage_3} style={{ width: 580 }} alt='第3阶段：闹元宵——收尾与希望' />
            </div>
            <div className={styles.stageTime}>
              <span>
                {$collectTime.stage3Start?.format('YYYY-MM-DD HH:mm')} ~{' '}
                {$collectTime.stage3End?.format('YYYY-MM-DD HH:mm')}
              </span>
              <div className={styles.stageStatus}>
                {$collectTimeStatus.stage3 === 'notStart' && (
                  <img src={img_not_start} style={{ height: 38 }} alt='未开始' />
                )}
                {$collectTimeStatus.stage3 === 'inProgress' && (
                  <img src={img_in_progress} style={{ height: 38 }} alt='进行中' />
                )}
                {$collectTimeStatus.stage3 === 'finished' && (
                  <img src={img_have_finished} style={{ height: 38 }} alt='已结束' />
                )}
              </div>
            </div>

            {/* 参与要求 */}
            <div className={[styles.stageRequirement, styles.contentBg].join(' ')}>
              <div className={styles.stageRequirementTitle}>
                <div className={styles.charBox}>
                  <div className={styles.charInner}>
                    <span>本</span>
                  </div>
                </div>
                <div className={styles.charBox}>
                  <div className={styles.charInner}>
                    <span>赛</span>
                  </div>
                </div>
                <div className={styles.charBox}>
                  <div className={styles.charInner}>
                    <span>段</span>
                  </div>
                </div>
                <div className={styles.charBox}>
                  <div className={styles.charInner}>
                    <span>参</span>
                  </div>
                </div>
                <div className={styles.charBox}>
                  <div className={styles.charInner}>
                    <span>与</span>
                  </div>
                </div>
                <div className={styles.charBox}>
                  <div className={styles.charInner}>
                    <span>要</span>
                  </div>
                </div>
                <div className={styles.charBox}>
                  <div className={styles.charInner}>
                    <span>求</span>
                  </div>
                </div>
              </div>
              <div className={styles.stageRequirementContent}>
                <div className={styles.stageRequirementItem} style={{ width: '50%' }}>
                  <div className={styles.stageRequirementItemTitle}>素材要求</div>
                  <div className={styles.stageRequirementItemText}>
                    本轮您需要在插画中融入以下素材：
                  </div>
                  <div className={styles.stageRequirementItemText}>
                    <strong>A· 抽取的3个盲盒</strong>
                  </div>
                  <div className={styles.stageRequirementItemText}>
                    <strong>B · 第2轮公示中的“信物”</strong>
                  </div>
                </div>
                <div className={styles.stageRequirementItem} style={{ width: '50%' }}>
                  <div className={styles.stageRequirementItemTitle}>提交成果</div>
                  <div className={styles.stageRequirementItemText}>
                    {/* 提交完整插画作品时，
                    <br />
                    <strong>还须将您承接的“信物”添加为作品的依赖资源</strong> */}
                    提交以“第3轮 - 作品主题”格式命名的完整插画作品，并将承接的“信物”添加为依赖。
                  </div>
                </div>
              </div>
            </div>
            {($collectTimeStatus.stage3 === 'inProgress' ||
              ($collectTimeStatus.stage3 === 'finished' && $luckyBox3Results.length > 0)) && (
              <div className={styles.extractMaterial}>
                <img src={img_extract_material} style={{ width: 244 }} alt='抽取本轮盲盒素材' />
                <div style={{ height: 10 }} />
                <LuckyBox
                  stage={3}
                  showBox={$luckyBox3Results.length === 0}
                  // disabled={$collectTimeStatus.stage3 !== 'inProgress'}
                  onResult={(results) => {
                    set$luckyBox3Results(results);
                  }}
                />
                {$luckyBox3Results.length > 0 && (
                  <div
                    style={{
                      display: 'flex',
                      gap: 50,
                      justifyContent: 'center',
                      alignItems: 'center',
                      paddingBottom: 10,
                    }}
                  >
                    {$luckyBox3Results.map((result, index) => (
                      <div
                        key={index}
                        style={{
                          display: 'flex',
                          flexDirection: 'column',
                          alignItems: 'center',
                          gap: 20,
                        }}
                      >
                        <img
                          key={index}
                          src={result.imgUrl}
                          alt={result.name}
                          style={{ width: 240, height: 240, display: 'block' }}
                        />
                        <div style={{ fontSize: 16, color: '#000' }}>{result.name}</div>
                      </div>
                    ))}
                  </div>
                )}
                <div style={{ height: 20 }} />
                {$luckyBox3Results.length > 0 ? (
                  <div className={styles.extractMaterialText}>抽取完成</div>
                ) : (
                  <div className={styles.extractMaterialText}>点击上方礼盒抽取素材</div>
                )}
                <div style={{ height: 15 }} />
                <div className={styles.extractMaterialText2}>
                  请将抽取的3个盲盒素材，以个人风格融入插画，而非直接使用参考图形
                </div>
                <div style={{ height: 20 }} />
                <div className={styles.qualificationButtons}>
                  <div
                    className={[
                      styles.qualificationButton,
                      $collectTimeStatus.stage3 !== 'inProgress' ? styles.disabled : '',
                    ].join(' ')}
                    onClick={() => {
                      if (get$collectTimeStatus().stage3 !== 'inProgress') {
                        return;
                      }
                      commitWorks();
                    }}
                  >
                    提交作品
                  </div>
                </div>
              </div>
            )}

            {$momentTime.isBefore($collectTime.stage3Announce) && (
              <div className={styles.stageResult}>
                第三轮评选结果将于 {$collectTime.stage3Announce?.format('YYYY-MM-DD HH:mm')} 公开
              </div>
            )}
            {$momentTime.isAfter($collectTime.stage3Announce) && (
              <div className={styles.stageResultBox}>
                <div className={styles.stageResult}>
                  第三轮评选结果 {$collectTime.stage3Announce?.format('YYYY-MM-DD HH:mm')}
                </div>
                <div style={{ height: 10 }} />
                <div className={styles.resultTitle}>最佳创意作品</div>
                <div style={{ height: 20 }} />

                <div className={[styles.bestWorkContent, styles.contentBg].join(' ')}>
                  {/* 作者卡片 */}
                  <div className={styles.authorCard}>
                    <div className={styles.authorCardTitle}>作者</div>
                    <div className={styles.authorCardAvatar}>
                      <img src={$topicResults?.topic5?.avatar} alt='作者头像' />
                    </div>
                    <div className={styles.authorCardName}>{$topicResults?.topic5?.username}</div>
                    <div style={{ height: 20 }} />
                  </div>

                  {/* 资源卡片 */}
                  <div
                    className={styles.resourceCardBest}
                    // onClick={() => {
                    //   window.open(
                    //     FUtil.Format.completeUrlByDomain('console') +
                    //       FUtil.LinkTo.resourceDetails({
                    //         resourceID: get$topicResults()?.topic5?.work?.resourceID || '',
                    //       }),
                    //   );
                    // }}
                  >
                    <div className={styles.resourceCardBestTitle}>参赛作品</div>
                    <div
                      className={styles.resourceCardBestCover}
                      style={{
                        backgroundImage:
                          'url(' + ($topicResults?.topic5?.work?.resourceCover || '') + ')',
                      }}
                      onClick={() => {
                        openResourceDetails($topicResults?.topic5?.work?.resourceID || '');
                      }}
                    >
                      <div />
                      <article
                        style={{
                          backgroundImage:
                            'url(' + ($topicResults?.topic5?.work?.resourceCover || '') + ')',
                        }}
                      />
                    </div>
                    <div
                      className={styles.resourceCardBestName}
                      onClick={() => {
                        openResourceDetails($topicResults?.topic5?.work?.resourceID || '');
                      }}
                    >
                      {$topicResults?.topic5?.work?.resourceTitle}
                    </div>
                    <div className={styles.resourceCardBestMaterials}>
                      <span>盲盒素材：</span>
                      {$topicResults?.topic5?.work?.materials.map((material, index) => {
                        return <span key={index}>{material}</span>;
                      })}
                    </div>
                  </div>
                </div>

                <div
                  style={{
                    height: 30,
                    display: ($topicResults?.topic6?.length ?? 0) > 0 ? 'block' : 'none',
                  }}
                />
                <div
                  className={styles.resultTitle}
                  style={{ display: ($topicResults?.topic6?.length ?? 0) > 0 ? 'block' : 'none' }}
                >
                  优秀入围作品
                </div>
                <div
                  style={{
                    height: 20,
                    display: ($topicResults?.topic6?.length ?? 0) > 0 ? 'block' : 'none',
                  }}
                />

                <div
                  className={[styles.excellentWorks, styles.contentBg].join(' ')}
                  style={{ display: ($topicResults?.topic6?.length ?? 0) > 0 ? 'flex' : 'none' }}
                >
                  {$topicResults?.topic6.map((topic) => {
                    return (
                      <div
                        className={styles.excellentResourceCard}
                        key={topic.resourceID}
                        // onClick={() => {
                        // window.open(
                        //   FUtil.Format.completeUrlByDomain('console') +
                        //     FUtil.LinkTo.resourceDetails({
                        //       resourceID: topic.resourceID,
                        //     }),
                        // );
                        // }}
                      >
                        <div
                          className={styles.excellentResourceCover}
                          style={{
                            backgroundImage: 'url(' + (topic.resourceCover || '') + ')',
                          }}
                          onClick={() => {
                            openResourceDetails(topic.resourceID);
                          }}
                        >
                          <div />
                          <article
                            style={{
                              backgroundImage: 'url(' + (topic.resourceCover || '') + ')',
                            }}
                          />
                        </div>
                        <div
                          className={styles.excellentResourceName}
                          onClick={() => {
                            openResourceDetails(topic.resourceID);
                          }}
                        >
                          <span className={styles.excellentResourceNameText}>
                            {topic.resourceTitle}
                          </span>
                        </div>
                        <div className={styles.excellentResourceAuthor}>
                          <div className={styles.excellentAuthorAvatar}>
                            <img src={topic.avatar} alt='作者头像' />
                          </div>
                          <span className={styles.excellentAuthorName}>{topic.username}</span>
                        </div>
                        <div className={styles.excellentMaterialInfo}>
                          <span>盲盒素材：</span>
                          {topic.materials.map((material, index) => {
                            return <span key={index}>{material}</span>;
                          })}
                        </div>
                      </div>
                    );
                  })}
                </div>
              </div>
            )}
          </div>
        </div>

        {/* 奖励设置 */}
        <div className={styles.section} ref={ref_content4}>
          <div className={styles.sectionTitle}>
            <div className={styles.titleLeft}></div>
            <div className={styles.titleCenter}>
              {/* <span>奖励设置</span> */}
              <img src={img_award_setting} style={{ height: 104 }} alt='奖励设置' />
            </div>
            <div className={styles.titleRight}></div>
          </div>

          <div className={styles.rewards}>
            <div className={styles.rewardRow}>
              <div className={[styles.rewardCard, styles.rewardBg].join(' ')}>
                <div className={styles.rewardCardTitle}>
                  <span>最佳创意奖 3个</span>
                </div>
                <div className={styles.rewardAmount}>¥500</div>
                <div className={styles.rewardDesc}>
                  Freelog官方将从三轮接龙作品中，评选出3个最佳创意奖，分别奖励¥500
                </div>
                <div className={styles.rewardNote}>
                  为鼓励更多创作者参与，此项奖励的 三位获奖者不可重复
                </div>
              </div>
              <div className={[styles.rewardCard, styles.rewardBg].join(' ')}>
                <div className={styles.rewardCardTitle}>
                  <span>优秀入围奖 9个</span>
                </div>
                <div className={styles.rewardAmount}>¥200</div>
                <div className={styles.rewardDesc}>
                  除最佳创意奖外，每轮还将评选出3个优秀入围作品（共计 9 个），分别奖励 ¥200
                </div>
              </div>
            </div>

            <div className={styles.rewardRow}>
              <div className={[styles.rewardCard, styles.rewardBg].join(' ')}>
                <div className={styles.rewardCardTitle}>
                  <span>全程参与奖</span>
                </div>
                <div className={styles.rewardAmount}>¥50</div>
                <div className={styles.rewardDesc}>
                  凡是在三轮接力均成功提交作品者，可获得¥50奖励
                </div>
                <div className={styles.rewardStatus}>
                  {$isAllParticipate ? '已获资格' : '未获资格'}
                </div>
              </div>
              <div className={[styles.rewardCard, styles.rewardBg].join(' ')}>
                <div className={styles.rewardCardTitle}>
                  <span>新春达人奖 3个</span>
                </div>
                <div className={styles.rewardAmount}>¥100</div>
                <div className={styles.rewardDesc}>
                  累计提交完整插画作品数量排名前三的创作者，将分别获得¥100奖励
                </div>
              </div>
            </div>

            <div className={[styles.rewardCardSpecial, styles.rewardBg].join(' ')}>
              <div className={styles.rewardCardTitle}>
                <span>新春同乐奖</span>
              </div>
              <div className={styles.rewardDesc}>
                所有成功提交作品并分享活动页至社交平台的创作者，即可获得新春同乐奖的参与资格！
              </div>
              <div className={styles.rewardPool}>
                <div className={styles.rewardPoolItem}>
                  <div className={styles.rewardPoolLabel}>初始奖池</div>
                  <div className={styles.rewardPoolAmount}>¥50</div>
                </div>
                <div className={styles.rewardPoolItem}>
                  <div className={styles.rewardPoolLabel}>参与≥20人</div>
                  <div className={styles.rewardPoolAmount}>解锁 ¥200 奖池</div>
                </div>
                <div className={styles.rewardPoolItem}>
                  <div className={styles.rewardPoolLabel}>参与≥50人</div>
                  <div className={styles.rewardPoolAmount}>解锁 ¥800 奖池</div>
                </div>
                <div className={styles.rewardPoolItem}>
                  <div className={styles.rewardPoolLabel}>参与≥100人</div>
                  <div className={styles.rewardPoolAmount}>解锁 ¥3000 奖池</div>
                </div>
              </div>
              <div className={styles.rewardStatus}>
                {$hasSpringFestivalJoyPrize ? '已获资格' : '未获资格'}
              </div>
            </div>

            <div className={styles.rewardEgg}>
              <div className={styles.rewardEggTitle}>
                <img src={img_painted_eggshell} style={{ height: 60 }} alt='彩蛋' />
              </div>
              <div className={styles.rewardEggContent}>
                <div className={styles.rewardEggImage}>
                  <img src={imgRedPacket} alt='彩蛋1' />
                </div>
                <div className={styles.rewardEggImage}>
                  <img src={img_red_packet_cover} alt='红包封面' />
                </div>
              </div>
              <div className={styles.rewardEggText}>
                最佳创意奖和优秀入围奖，将获得官方全力助推，
                <br />
                不仅会被收录于Freelog编辑精选推荐中，享受资源市场和首页推荐位，
                <br />
                也可以授权Freelog，共同打造联名版微信红包封面！
              </div>
              {$momentTime.isBefore(activityDetailsPage.announceTime) && (
                <div className={styles.rewardTime}>
                  获奖名单将于 {activityDetailsPage.announceTime?.format('YYYY-MM-DD HH:mm')} 公布
                </div>
              )}
              {$momentTime.isAfter(activityDetailsPage.announceTime) && (
                <div
                  className={styles.rewardButton}
                  onClick={() => {
                    set$announceShow(true);
                  }}
                >
                  查看获奖公示
                </div>
              )}
            </div>
          </div>
        </div>

        {/* 新手指南 */}
        <div className={styles.section} ref={ref_content5}>
          <div className={styles.sectionTitle}>
            <div className={styles.titleCenter}>
              {/* <span>新手指南</span> */}
              <img src={img_newbie_guide} style={{ height: 104 }} alt='新手指南' />
            </div>
          </div>

          <div className={styles.guide}>
            <div className={styles.guideSection}>
              <div className={styles.guideSectionTitle}>
                <img src={img_submission_of_works} style={{ height: 52 }} alt='提交作品指南' />
              </div>
              <div className={styles.guideSteps}>
                <div className={styles.guideStepWithBg}>
                  <div className={styles.guideStepBg}>
                    <img src={img_guide_step_1_bg} alt='' />
                  </div>
                  <div className={styles.guideStepNumber} style={{ width: 232, top: 52 }}>
                    第1步：选择资源类型
                  </div>
                  {/* <div className={styles.guideStepText}>
                    点击"提交作品"，进入创建资源流程，
                    <br />
                    选择资源类型"图片"→"插画"。
                  </div> */}
                  <div className={styles.guideStepTextLine1} style={{ top: 111 }}>
                    <div>•</div>
                    <div>点击“提交作品”，进入创建资源流程；</div>
                  </div>
                  <div className={styles.guideStepTextLine2} style={{ top: 148 }}>
                    <div>•</div>
                    <div>
                      上传完整插画，选择资源类型“图片”→“插画”，标题以“第x轮 - 作品主题”格式命名；
                    </div>
                  </div>
                  <div className={styles.guideStepTextLine3} style={{ top: 210 }}>
                    <div>•</div>
                    <div>
                      上传指定“信物”，选择资源类型“图片”→“矢量图”，标题须以“第x轮 - 作品主题 -
                      信物”格式命名。
                    </div>
                  </div>
                </div>
                <div className={styles.guideStepWithBg2}>
                  <div className={styles.guideStepBg}>
                    <img src={img_guide_step_2_bg} alt='' />
                  </div>
                  <div className={styles.guideStepNumber} style={{ width: 231, top: 90 }}>
                    第2步：上传活动作品
                  </div>
                  <div className={styles.guideStepTextLine1} style={{ top: 149 }}>
                    <div>•</div>
                    {/* <div>上传符合活动作品提交要求的完整插画作品；</div> */}
                    <div>上传符合活动作品提交要求的完整插画或“信物”文件；</div>
                  </div>
                  <div className={styles.guideStepTextLine2} style={{ top: 186 }}>
                    <div>•</div>
                    {/* <div>
                      参与"新年信物 • 插画接龙"第1~2轮的作品，
                      <br />
                      须一并提交您指定的"信物"；
                    </div> */}
                    <div>
                      参加“新年信物 •
                      插画接龙”第2~3轮时，请在上传完整插画文件后，将上一轮最佳创意作品中的指定「信物」添加为“依赖”；
                    </div>
                  </div>
                  {/* <div className={styles.guideStepTextLine3}>
                    <div>•</div>
                    <div>
                      参与"新年信物 • 插画接龙"第2~3轮的作品，
                      <br />
                      须在上传文件后，为其添加"依赖声明"；
                    </div>
                  </div> */}
                  <div
                    className={styles.guideStepLink}
                    style={{ top: 286 }}
                    onClick={() => {
                      self.open(
                        'https://freelog3.freelog.cn/?theme=%2Freader%3Fid%25M262d0d04f456ff0002e329537%25M1title%25M22.%E5%A6%82%E4%BD%95%E6%B7%BB%E5%8A%A0%E4%BE%9D%E8%B5%96%E5%A3%B0%E6%98%8E&w06c513=%2F',
                      );
                    }}
                  >
                    查看如何添加依赖声明
                  </div>
                </div>

                <div className={styles.guideStepWithBg3}>
                  <div className={styles.guideStepBg}>
                    <img src={img_guide_step_3_bg} alt='' />
                  </div>
                  <div className={styles.guideStepNumber} style={{ width: 231 }}>
                    第3步：添加授权策略
                  </div>
                  <div className={styles.guideStepTextMain}>
                    添加并启用一个授权策略，
                    <br />
                    以确保其能够成功在资源市场上架！
                  </div>
                  <div className={styles.guideStepNote}>
                    【授权策略】是资源作者对于资源的权利声明，包含授权对象、授权范围和授权主张等信息。在Freelog平台，资源需添加并启用授权策略后，才能上架资源市场并开放签约。
                  </div>
                </div>

                <div className={styles.guideStepWithBg4}>
                  <div className={styles.guideStepBg}>
                    <img src={img_guide_step_4_bg} alt='' />
                  </div>
                  <div className={styles.guideStepNumber} style={{ width: 231 }}>
                    第4步：完善活动信息
                  </div>
                  <div className={styles.guideStepTextMain}>
                    为您精心创作的插画作品添加专属活动标签
                  </div>
                  <div className={styles.guideStepHint}>点击复制标签</div>
                  <div
                    className={styles.guideTag}
                    style={{ cursor: 'pointer' }}
                    onClick={() => {
                      copy('#2026"新年信物 • 插画接龙"创作赛#', {
                        format: 'text/plain',
                      });
                      fCenterMessage({ message: '复制成功' });
                    }}
                  >
                    #2026"新年信物 • 插画接龙"创作赛#
                  </div>
                </div>
              </div>
            </div>
            <div style={{ height: 20 }} />
            <div className={styles.guideSection}>
              <div className={styles.guideSectionTitle}>
                <img src={img_official_channels} style={{ height: 52 }} alt='官方答疑渠道' />
              </div>
              <div className={styles.guideQRCodes}>
                <div
                  className={styles.guideQRCode}
                  style={{ cursor: 'pointer' }}
                  onClick={() => {
                    self.open('https://www.xiaohongshu.com/user/profile/64c0d3810000000014039a75');
                  }}
                >
                  <div className={styles.guideQRCodeImage}>
                    <img src={img_xiaohongshu_qr} alt='小红书二维码' />
                  </div>
                  <div className={styles.guideQRCodeLabel}>小红书</div>
                </div>
                <div
                  className={styles.guideQRCode}
                  style={{ cursor: 'pointer' }}
                  onClick={() => {
                    self.open('https://weibo.com/freelogofficial');
                  }}
                >
                  <div className={styles.guideQRCodeImage}>
                    <img src={img_weibo_qr} alt='微博二维码' />
                  </div>
                  <div className={styles.guideQRCodeLabel}>微博</div>
                </div>
                <div className={styles.guideQRCode}>
                  <div className={styles.guideQRCodeImageSquare}>
                    <img src={img_qq_qr} alt='QQ群二维码' />
                  </div>
                  <div className={styles.guideQRCodeLabel}>官方活动答疑QQ群</div>
                </div>
                <div className={styles.guideQRCode}>
                  <div className={styles.guideQRCodeImageSquare}>
                    <img src={img_weixin_qr} alt='微信二维码' />
                  </div>
                  <div className={styles.guideQRCodeLabel}>官方活动答疑微信</div>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* 活动规则 */}
        <div className={styles.section} ref={ref_content6}>
          <div className={styles.sectionTitle}>
            {/* <div className={styles.titleLeft}></div> */}
            <div className={styles.titleCenter}>
              <img src={img_activity_rules} style={{ height: 104 }} alt='活动规则' />
            </div>
            {/* <div className={styles.titleRight}></div> */}
          </div>

          <div className={styles.creativeThemeRequirements}>
            <div className={styles.requirementSection}>
              <div className={styles.requirementSectionTitle}>1、活动时间规则：</div>
              <div className={styles.requirementContent}>
                1.1 活动期限：本次活动征集时间为
                {activityDetailsPage.startTime?.format('YYYY-MM-DD HH:mm')}至
                {activityDetailsPage.endTime?.format('YYYY-MM-DD HH:mm')}
                ，为保证您的活动参与体验，请尽量使用PC端访问freelog网页版；
              </div>
              <div className={styles.requirementContent}>
                1.2 结果公示：最终活动结果将于
                {activityDetailsPage.announceTime?.format('YYYY-MM-DD HH:mm')}公布。
              </div>
            </div>

            <div className={styles.requirementSection}>
              <div className={styles.requirementSectionTitle}>2、参赛者须知：</div>
              <div className={styles.requirementContent}>
                2.1 参赛作品须在活动截止前提交，逾期提交的作品将无法进入本期评审流程。
              </div>
              <div className={`${styles.requirementContent} ${styles.requirementContentInter}`}>
                2.2
                参赛作品需在活动结算后，在Freelog资源市场保持上架状态≥12个月，以确保Freelog用户正常使用体验。
              </div>
              <div className={styles.requirementContent}>
                2.3
                严禁上传空白文件、无实质内容的资源，以及其他任何形式的虚假或无意义资源。一经发现，相关资源将无法参与活动评选。
              </div>
              <div className={`${styles.requirementContent} ${styles.requirementContentInter}`}>
                2.4 参赛作品原创性与版权规则
                <br />
                用户发布的资源必须为原创作品，禁止抄袭、搬运;
                <br />
                对于合作创作的资源，参与各方应协商一致，通过一个指定的特定账号进行发布。严禁多人使用各自账号重复发布相同或相似的合作资源；
                <br />
                用户需确保对发布的资源拥有完整的著作权或已获得必要的授权，若因未获得授权或侵犯他人版权导致任何法律纠纷，Freelog平台不承担任何法律责任。相关责任由侵权用户自行承担；
                <br />
                若作品存在以上违规情形，则平台有权直接取消作品的参与资格，已分配的全部奖金即时取消或追回。
              </div>
              <div className={`${styles.requirementContent} ${styles.requirementContentInter}`}>
                2.5
                所有用户须遵守《Freelog平台管理规范》，若发现用户存在违反平台管理规范的行为，则平台有权直接取消其作品的参与资格，已分配的全部奖金即时取消或追回。
              </div>
            </div>

            <div className={styles.requirementContent}>
              3、活动期间开放投诉通道，用户可以通过联系官方工作人员或向Freelog发送邮件（service@freelog.com）对涉嫌违规的行为和用户进行投诉。投诉邮件内容需包含被投诉作品名称、作品链接、涉嫌违规原因，否则不予处理；
            </div>

            <div className={styles.requirementContent}>
              4、活动最终解释权归Freelog所有，如有疑问请联系官方工作人员或发送邮件至官方邮箱service@freelog.com。
            </div>
          </div>
        </div>
        {/* <div style={{ height: 120 }} /> */}
        <FFooter style={{ backgroundColor: 'rgba(255, 255, 255, 0.4)' }} />

        {Array.from({ length: 50 }).map((_, index) => (
          <React.Fragment key={index}>
            <img
              src={img_sider_bg}
              alt=''
              className={[styles.siderBg, styles.left].join(' ')}
              style={{ top: index * 650 + self.innerHeight }}
            />
            <img
              src={img_sider_bg}
              alt=''
              className={[styles.siderBg, styles.right].join(' ')}
              style={{ top: index * 650 + self.innerHeight }}
            />
          </React.Fragment>
        ))}

        {/* 侧边导航 */}
        <div className={styles.sideNavContainer}>
          <div className={styles.sideNav}>
            <div
              className={[
                styles.sideNavItem,
                $activated === 1 ? styles.sideNavItemActive : '',
              ].join(' ')}
              onClick={() => {
                const info: DOMRect | undefined = ref_content1.current?.getBoundingClientRect();
                // console.log(info, 'info');
                scrollTo((info?.top || 0) - 70);
              }}
            >
              活动时间
            </div>
            <div className={styles.sideNavDivider}></div>
            <div
              className={[
                styles.sideNavItem,
                $activated === 2 ? styles.sideNavItemActive : '',
              ].join(' ')}
              onClick={() => {
                const info: DOMRect | undefined = ref_content2.current?.getBoundingClientRect();
                scrollTo((info?.top || 0) - 70);
              }}
            >
              活动机制
            </div>
            <div className={styles.sideNavDivider}></div>
            <div
              className={[
                styles.sideNavItem,
                $activated === 3 ? styles.sideNavItemActive : '',
              ].join(' ')}
              onClick={() => {
                const info: DOMRect | undefined = ref_content3.current?.getBoundingClientRect();
                scrollTo((info?.top || 0) - 70);
              }}
            >
              参与方式
            </div>
            <div className={styles.sideNavDivider}></div>
            <div
              className={[
                styles.sideNavItem,
                $activated === 4 ? styles.sideNavItemActive : '',
              ].join(' ')}
              onClick={() => {
                const info: DOMRect | undefined = ref_content4.current?.getBoundingClientRect();
                scrollTo((info?.top || 0) - 70);
              }}
            >
              奖励设置
            </div>
            <div className={styles.sideNavDivider}></div>
            <div
              className={[
                styles.sideNavItem,
                $activated === 5 ? styles.sideNavItemActive : '',
              ].join(' ')}
              onClick={() => {
                const info: DOMRect | undefined = ref_content5.current?.getBoundingClientRect();
                scrollTo((info?.top || 0) - 70);
              }}
            >
              新手指南
            </div>
            <div className={styles.sideNavDivider}></div>
            <div
              className={[
                styles.sideNavItem,
                $activated === 6 ? styles.sideNavItemActive : '',
              ].join(' ')}
              onClick={() => {
                const info: DOMRect | undefined = ref_content6.current?.getBoundingClientRect();
                scrollTo((info?.top || 0) - 70);
              }}
            >
              活动规则
            </div>
          </div>
        </div>

        {/* 提交作品快捷入口 */}
        <div className={styles.submitButtonContainer} onClick={commitWorks}>
          <div className={styles.submitButton}>
            <img src={imgSubmitIcon} alt='' />
            <span>提交作品</span>
          </div>
        </div>

        {/* 分享活动按钮 */}
        <div
          className={styles.shareButtonContainer}
          onClick={async () => {
            fWeiXinShare({
              configs: {
                title: activityDetailsPage.pageTitle,
                desc: activityDetailsPage.description,
                link: self.location.href,
                imgUrl: activityDetailsPage.cover,
              },
            });

            // await FServiceAPI.Activity.statisticTaskRecords({
            //   codes: ['TS001212'],
            // });
            await FServiceAPI.Activity.pushMessageTask({
              taskConfigCode: 'TS001212',
              // meta: { linkUrl: get$value() },
            });
            await FServiceAPI.Activity.pushMessageTask({
              taskConfigCode: 'TS0001004',
              meta: { activityId: activityDetailsPage.activityID },
            });
            await FServiceAPI.Activity.pushMessageTask({
              taskConfigCode: 'T0001004',
              meta: { activityId: activityDetailsPage.activityID },
            });
          }}
        >
          <div className={styles.shareButton}>
            <img src={imgShareIcon} alt='' />
            <span>分享活动</span>
          </div>
        </div>

        <WinnerAnnouncementModal
          open={$announceShow}
          onClose={() => {
            set$announceShow(false);
          }}
          bestCreative={$winnerAnnouncement.bestCreative}
          excellent={$winnerAnnouncement.excellent}
          fullParticipationUsernames={$winnerAnnouncement.fullParticipationUsernames}
          springExpertUsernames={$winnerAnnouncement.springExpertUsernames}
          onResourceClick={openResourceDetails}
        />
      </div>
    </>
  );
}

export default connect(({ activityDetailsPage }: ConnectState) => ({
  activityDetailsPage,
}))(SpringFestival2026);

function scrollTo(top: number) {
  self.document.querySelector('#layout-content .simplebar-content-wrapper')?.scrollBy({
    top,
    behavior: 'smooth',
  });
}

function openResourceDetails(resourceID: string) {
  window.open(
    FUtil.Format.completeUrlByDomain('console') +
      FUtil.LinkTo.resourceDetails({
        resourceID: resourceID,
      }),
    '_blank',
  );
}
